import React from "react";
import HeroBanner from "../Components/SolutionBanner/solutionBanner";
import PriceGlance from "../Components/PriceGlance/priceglance"
import ImageText from "../Components/RightImageWithText/index";
import WhatWeDo from "../Components/WhatWeDo/index";
import CoreSolutions from "../Components/CoreSolutions/coresolutions"
import WhoWeSupport from "../Components/WhoWeSupport/whowesupport"
import CTASection from "../Components/CTASection/ctaButton"
import HowWeStarted from "../Components/HowWeStarted/index"
import WhatMakeUsDifferent from "../Components/WhatMakesUsDifferent/index"
import MeetOurTeam from "../Components/MeetOurTeam/index"
import TrustedBy from "../Components/TrustedBy/index"
import LogoBrand from "../Components/LogoBrand/index"
import InterestedIn from "../Components/InterestedIn/index"
import BoxesSection from "../Components/BoxesSection/index"
import SliderSection from "../Components/SliderSection/index"

const About = () => {
    return (
        <>
            <HeroBanner />
            {/* <ImageText />
            <WhatWeDo /> */}
            <CoreSolutions />
            {/* <PriceGlance /> */}
            <WhoWeSupport />
            <CTASection />
            {/* <WhatMakeUsDifferent /> */}
            {/* <HowWeStarted /> */}
            {/* <MeetOurTeam /> */}
            {/* <TrustedBy /> */}
            {/* <SliderSection /> */}
            {/* <LogoBrand /> */}
            {/* <InterestedIn /> */}
            {/* <BoxesSection /> */}
        </>
    );
}

export default About;